export * from "./masked";

import { ICoreProps, Input } from "@mds/react-components";

type IInputProps = ICoreProps;

export { Input, IInputProps };
